<template>
  <div>
    <div  v-if="windowSize>=992" style="width:100%" class="d-none d-md-block"> 
        <table  style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
          <thead  :class="{'opacity-table': tableTable>=0  && typeof tableTable === 'number' }">            
            <tr>  
              <th v-for="(items,index) in tableItems" :key="'thGet'+index" style="vertical-align:top">  
                <b-row>
                  <b-col style="padding:0;">
                    {{items.thead.th}}      
                  </b-col>
                </b-row> 
              </th>              
            </tr>
          </thead>
          <tbody>
            <tr v-for="(items,index) in sortedTable()" :key="'dataGetHeader'+index" style="position:relative;">
              <td v-if="items.tableTable!==undefined" :colspan="colspan()" class="bg-light box-effect linear">             
                    <sw-tabletable
                        :tableItems="table.items"
                        :tableSearch="table.search"
                        :tableOptions="table.options"
                        :tableIndex="table.index"
                        :tabla="table.tabla"
                        :name="table.tabla"
                        >
                    </sw-tabletable>                  
              </td>
              <td :class="{'opacity-table': (tableTable>=0 && tableTable!==items.index && opentabletable!==items2  && typeof tableTable === 'number') || awaitDataGet}" v-for="(items2,index2) in tableItems" :key="'tdGet'+index2" v-if="items.tableTable===undefined" >
                  <div v-if="items2.tbody.td">
                    <div>
                      <div v-if="!items2.tbody.link">
                        <span style="display: inline-block;" :class="{'pr-1': items2.tbody.td.length>1}"  v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                          <span v-if="items2.tbody.checks">
                            <span v-if="items[items4]===true">
                              {{items2.tbody.checks[index4]}}  
                            </span>                  
                          </span>
                          <span v-else>
                            <span v-if="items4.includes('text/')">
                                {{items4.replace('text/','')}}
                            </span>
                            <span v-if="items2.tbody.ftn!==undefined">
                              {{items2.tbody.ftn(items[items4])}}
                            </span>
                            <span v-else>
                              <span v-if="items2.tbody.show!==undefined && items[items2.tbody.show.td]==items2.tbody.show.compare">
                                {{items[items4]}} 
                              </span>
                              <span v-if="items2.tbody.show===undefined">
                                {{items[items4]}} 
                              </span>
                            </span>                                       
                          </span>
                        </span>
                      </div>
                      <div v-else>
                        <div v-if="(items[items2.tbody.td[0]]!==null && items[items2.tbody.td[0]]!=='') || (items[items2.tbody.td[0]]!==null && JSON.parse(items[items2.tbody.td[0]]).length>0)">
                          <b-button v-if="items2.tbody.show===undefined" variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]],items2.tbody.archivo)" class="btn-link">Pdf</b-button>
                          <b-button v-if="items2.tbody.show!==undefined && items[items2.tbody.show.td]==items2.tbody.show.compare" variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]],items2.tbody.archivo)" class="btn-link">Pdf</b-button>
                          <span v-if="items2.tbody.show!==undefined && items[items2.tbody.show.td]!=items2.tbody.show.compare" >
                            {{items2.tbody.show.else}}
                          </span>
                        </div>
                      </div>                                    
                    </div>
                  </div>
                  <div v-if="items2.tbody.table && items[items2.tbody.table.tabla].length>0" style="position:relative">  
                      <b-icon :id="items.index+'popover'+index2"  @click="openTable(index,items2.tbody.table,items.index,index2);items.tableTable!=items.tableTable"  class="option-btn" icon="table" scale="1.3" variant="secondary"></b-icon>
                      <b-icon icon="shift-fill" scale="1.7" class="tableIcon" v-if="tableTable===items.index && opentabletable===index2 && !items2.thead.btn" rotate="180" variant="secondary"></b-icon>
                  </div>
              </td> 
            </tr>
          </tbody>
        </table>       
    </div>
    <div  v-if="windowSize<992" style="width:100%;" class="d-md-none">       
      <table   style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
        <thead>
          <tr>
            <th  v-for="(items,index) in tableItems" :key="'thGetMovil'+index" v-if="items.thead.movil">{{items.thead.th}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items,index) in sortedTable()" :key="'dataGetTableMovil'+index" style="position:relative;">
            <td   v-for="(items2,index2) in tableItems" :key="'thGetMovil'+index2" v-if="items2.thead.movil && items.tableTable===undefined">
              <span v-for="items3,index3 in items2.tbody.td" :key="'tdGetMovil'+index3">
                {{items[items3]}}
              </span>              
            </td>
            <td style="background: #f0f0f0" :colspan="colspan()"  v-if="items.tableTable!==undefined">
              <table style="width:100%">
                <tbody>
                  <tr  style="background: white" v-for="(items2,index2) in tableItems" :key="'thGetMovil2'+index2" v-if="items2.thead.movil===undefined">
                    <td>{{items2.thead.th}} :</td>
                    <td>
                      <div v-if="items2.tbody.td">
                        <div v-if="!items2.thead.btn">
                          <div v-if="!items2.tbody.link">
                            <span  style="display: inline-block;" v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                              <span v-if="items2.tbody.checks">
                                <span v-if="items[items4]===true">
                                  {{items2.tbody.checks[index4]}}  
                                </span>                  
                              </span>
                              <span v-else>
                                <span v-if="items4.includes('text/')">
                                    {{items4.replace('text/','')}}
                                </span>
                                <span v-if="items[items4]!==null">
                                  {{items[items4]}} 
                                </span>                                       
                              </span>
                            </span>
                          </div>
                          <div v-else>
                            <b-button variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]],items2.tbody.archivo)" class="btn-link">Pdf</b-button>
                          </div>                                    
                        </div>
                        <div v-if="items2.thead.btn">
                          <b-row>
                            <b-col md="2">
                              <b-form-checkbox
                                    size="lg"
                                    v-model="tableSave[name]['btn'+index2][items.index].check"
                                  >
                              </b-form-checkbox>
                            </b-col>                
                            <sw-inputstable
                              v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4"
                              :tablaCampo="items4"
                              :index="items.index"
                              :name="name"
                              :btn="'btn'+index2"
                              >
                            </sw-inputstable>
                          </b-row>
                        </div>
                      </div>
                      <div v-if="items2.tbody.table && items[items2.tbody.table.tabla].length>0" style="position:relative">  
                          <b-icon :id="items.index+'popover'+index2"  @click="openTableModal(items2.tbody.table,items.index,items2.thead.th)"  class="option-btn" icon="table" scale="1.3" variant="secondary"></b-icon>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>      
      <b-modal 
            v-if="openModalTable"
            v-model="openModal.modal.value"
            :title="openModal.modal.title" 
            :header-bg-variant="openModal.modal.variant"
            header-text-variant="light"
            :hide-footer="true"  
            :no-close-on-backdrop="true" 
            @hide="openModalTable=false"
            size="lg"  
            >           
              <sw-tabletable
                  :tableItems="table.items"
                  :tableSearch="table.search"
                  :tableOptions="table.options"
                  :tableIndex="table.index"
                  :tabla="table.tabla"
                  :name="table.tabla"
                  @save="save"
                  >
              </sw-tabletable>       
          </b-modal> 
    </div>
  </div>
</template>
<script>
import SwTabletable from '@/components/dataTable/tableTableHeader.vue'
import SwInputstable from '@/components/forms/inputsTable.vue'
import SwLoading from '@/components/notification/loading.vue'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
function cleanParameter(value)
  {
    if(value==null)
    {
      return '';
    }
    return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
export default 
{
  name: 'swTableHeader',
  components: { SwInputstable, SwTabletable, SwLoading  },
  props: {
    tableSearch: {
      type: Array,
      default: function()
      {
        return ['id']
      }
    },
    tableItems: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableOptions: {
      type: Object,
      default: function()
      {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    route: {
      type: String,
      default: ''
    },
    dataRoute: {
      default: ''
    },
    filterShow: {
      type: Boolean,
      default: true
    },
    options: {
      type: Boolean,
      default: true
    },
    warningClass: {
      default : null
    },
    buscarProp: {
      type: Boolean,
      default: true
    },
    paginationShow: {
      type: Boolean,
      default: true
    }

  },
  data () {
    return {
      currentSearch:'',
      currentSort:'id',
      currentSortDir: '', 
      tableTable: true, 
      opentabletable: false,
      openModalshow:false,
      openModalTable: false,
      table: {  
        items: [],
        search: [],
        options: {},
        name: '',
        index: 0,
      },
      pagination: 1,
      rows: 20,
      tableGetFilter: true,
      dataGetLength:0,
      thCheck: false     
    }
  },
  async created() { 
    window.addEventListener('resize', this.handleResize);
    this.handleResize();   
  },
  async updated()
  {   
  },
  computed: {    
  },
  methods: { 
    // COMPUTADOS O INICIALES
      sortedTable()
      {
        return this.deepCopyTable(this.dataGet.header.data)  
      },  
      colspan()
      {        
        let colspan=0
        if(this.tableOptions.options || this.tableOptions.modals)
        {
          colspan=1
        }
        return colspan + this.tableItems.length
      },
    // GLOBALES Y REUTILIZABLES

    // MEDIANTE UNA ACCION  
      openLinks(link,id,archivo)
      {
        if(archivo===undefined)
        {
          window.open( this.url+link+'?id='+id+'&token='+this.token,'_blank')
        }
        else 
        {
          id=JSON.parse(id)
          if(id.length>1)
          {
            window.open( this.url+'/api/pdf/archivos?data='+id+'&token='+this.token,'_blank')
          }
          else 
          {          
            if(id[0].includes('.pdf'))
            {
              window.open( this.url+link+'/'+id[0],'_blank')
            } 
            else 
            {
              window.open( this.url+'/api/pdf/archivos?data='+id+'&token='+this.token,'_blank')
            } 
            
          }
        }       
      },
      async openTable(index,table,itemIndex,indexopen)
      {
        let campoytabla       
        if(this.tableTable!==false) //si existe una table en el td
        {    
          if(this.tableTable!==true) // si esta abierta alguna table
          {
            this.dataGet.header.data.splice(1,1)   
          }
          if(itemIndex!==this.tableTable) // si la posicion del tr es diferente a la del tr con el table abierto
          {
            this.opentabletable=indexopen

            if(index>this.tableTable && this.tableTable!==true)
            {
              index=index-1
              itemIndex=itemIndex-1
            }
            this.tableTable = itemIndex
            this.table=table
            this.table.index=itemIndex  
            this.dataGet.header.data.splice(1,0,{tableTable: true})  
          }
          else{
            if(this.opentabletable===indexopen)
            {
              this.tableTable=true
            }
            else{
              this.opentabletable=indexopen
              if(index>this.tableTable && this.tableTable!==true)
              {
                index=index-1
                itemIndex=itemIndex-1
              }
              this.dataGet.header.data.splice(1,0,{tableTable: true})  
              this.tableTable = itemIndex
              this.table=table
              this.table.index=itemIndex              
            }          
          } 
        }        
      },
      async openTableMovil(index,table)
      {
        let indexopen=1
        let itemIndex=table.index
        let campoytabla        
        if(this.tableTable!==false) //si existe una table en el td
        {    
          if(this.tableTable!==true) // si esta abierta alguna table
          {
            this.dataGet.header.data.splice(this.tableTable+1,1)            
          }
          if(itemIndex!==this.tableTable) // si la posicion del tr es diferente a la del tr con el table abierto
          {
            this.opentabletable=indexopen

            if(index>this.tableTable && this.tableTable!==true)
            {
              index=index-1
              itemIndex=itemIndex-1
            }
            this.dataGet.header.data.splice(itemIndex+1,0,searchTableTable)  
            this.tableTable = itemIndex
          }
          else{
            if(this.opentabletable===indexopen)
            {
              this.tableTable=true
            }
            else{
              this.opentabletable=indexopen
              if(index>this.tableTable && this.tableTable!==true)
              {
                index=index-1
                itemIndex=itemIndex-1
              } 
            }          
          } 
        }
      },
      async openTableModal(table,itemIndex,title)
      {
        this.table=table
        this.table.index=itemIndex
        
        await this.updateGlobal({state: 'openModal/modal/title',    data: title})
        await this.updateGlobal({state: 'openModal/modal/modal',    data: title}) 
        await this.updateGlobal({state: 'openModal/modal/value',    data: true });
        
        this.openModalTable=true 
      },   
      handleResize(){
        this.windowSize = window.innerWidth;
      },
    // EVENTOS
  }
}
</script>
<style>
.sw-search{
  margin-bottom: 0 !important
}
.sw-search .input-group-text {
    border-radius: 0 0 0 0 !important;
}
.sw-search .search-radius{
    border-radius:  0 0.25rem 0 0 !important;
}
.table--get > thead tr{
  border-left: 1px solid #ced4da;
  border-right: 1px solid #ced4da;
}
.table--get > thead tr th{
    color: #495057;
    background-color: #e9ecef;
    vertical-align: bottom;
    border-bottom: 1px solid #dee2e6;
    border-top: none;
}
.sw-sort{
  background-image: url('/images/sort.svg');
  width: 11px;
  height: 18px;
  float: right;
  background-size: cover;
  margin-top: 3px;
  cursor:pointer;
}
.sw-sortdown{
  background-image: url('/images/sortdown.svg');
}
.sw-sortup{
  background-image: url('/images/sortup.svg');
}
.tableIcon{
    position: absolute;
    bottom: -22px;
    left: 0;
    color: #525173 !important;
}
.paginatable .page-link{
  color: #495057 ;
}
.paginatableget .active .page-link{
  background: #6c757d ;
  border-color:#6c757d;
}
.paginatableget .page-link{
  border-top: none;
}
.paginatableget .page-link:focus{
    box-shadow: none;
}
.paginatableget .page-item span:first-child{
  border-top-left-radius:0 !important;
}
.paginatableget .page-item:last-child .page-link{
  border-top-right-radius:0 !important;
}
.opacity-table{
  opacity: 0.3
}
.table--get{
  font-size: 15px;
}
.table--get > thead tr th{
  padding: 8px
}
.table--get > tbody tr td{
  padding: 8px
}
.input-group-prepend .btn
{
  border-radius:0 
}
.tableGet-warning {
  background: rgba(240,83,53,0.1) ;
}

</style>